<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				<!-- 身份证 -->
				<div class="id-tips" v-if="numTips==0">
					<div class="title">
						请将身份证放入<br>指定区域
					</div>
					<div class="equipment">
						<img src="../../assets/equipment.png" class="equipment-img">
						
						
						<img src="../../assets/id-gif.gif" class="gif">
						
					</div>
				</div>
				<!-- 社保卡 -->
				<div class="sbk-tips" v-else-if="numTips==1">
					<div class="title">
						请插入社保卡<br>等待读卡
					</div>
					<div class="equipment">
						<img src="../../assets/equipment.png" class="equipment-img">
						
						
						<img src="../../assets/shebao.gif" class="gif">
						
					</div>
				</div>
				<!-- 其他需要摄像头的 -->
				<div class="camera-tips" v-else>
					<div class="title" v-show="numTips==2">
						请将单据上的条形码<br>正对扫码器
					</div>
					<div class="title" v-show="numTips==3">
						请出示电子健康卡二维码<br>正对扫码器
					</div>
					<div class="title" v-show="numTips==4">
						请出示医保电子凭证<br>正对扫码器
					</div>
					<div class="title" v-show="numTips==6">
						请出示武汉战疫健康码<br>正对扫码器
					</div>

					<div class="equipment">
						<img src="../../assets/equipment.png" class="equipment-img">
						
						
						<img src="../../assets/camera.png" class="gif">
						
					</div>
				</div>
				
				
				<div class="button-group">
					<div class="button-blue fcc" @click="closePopTips">
						<img src="../../assets/icon/icon-return.png" >
						<span>返回</span>
						<span>（{{time321}}s）</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-pop-read-tips',
		props: {
			numTips:{
				type:[String,Number],
				default:null
			}
		},
		data() {
			return {
				timer:null,
				show:true,
				time321:30
			}
		},
	
		
		mounted() {
			var that = this;
			that.timer = setInterval(function() {
				that.time321--
				if (that.time321 < 1) {
					clearInterval(that.timer)
					that.closePopTips()
				}
			}, 1000)
		},
		methods: {
			closePopTips() {
				this.$emit("tips-close",false)
				clearInterval(this.timer);
			},
		},
		beforeDestroy() {
			clearInterval(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	
		.title{
			font-size: 45px;
			padding-top: 50px;
			font-weight: 800;
			color: #000000;
			line-height: 73px;
		}
		.gif{
			position: absolute;
				left: 252px;
				top: 55px;
		}
		
		.equipment-img{
			display: block;
			width: 100%;
			height: 100%;
		}
		
		.equipment{
			width: 167px;
			height: 433px;
			position: absolute;
			left: 124px;
			top: 260px;
		}
	
		.id-tips{
			.equipment{
				&:before{
					content: "";
					display: block;
					background: url(../../assets/id-tips.png) no-repeat;
					width: 472px;
					height: 310px;
					position: absolute;
					top: 8px;
					left: 35px;
				}
			}
		}
		.sbk-tips{
			.gif{
				top: 106px;
			}
			.equipment{
				&:before{
					content: "";
					display: block;
					background: url(../../assets/sbk-tips.png) no-repeat;
					width: 472px;
					height: 310px;
					position: absolute;
					top: 8px;
					left: 127px;
				}
			}
		}
		.camera-tips{
			.gif{
				left: 242px;
			
				top: 86px;
			}
			.equipment{
				&:before{
					content: "";
					display: block;
					background: url(../../assets/camera-tips.png) no-repeat;
					width: 405px;
					height: 310px;
					position: absolute;
					top: 8px;
					left: 90px;
				}
			}
		}
		.button-group{
			position: absolute;
			right: 47px;
			bottom: 54px;
		}
		.inner{
			padding: 0 47px 0;
			text-align: center;
			
			
			
			
		}
		
		
</style>
